import React, { useState, useEffect, useRef } from "react";
import { Dropdown, ButtonGroup } from "react-bootstrap";
import Loader from "../loader/loader";
import AddIntent from "./AddIntent";
import AddFlow from "./AddFlow";
import AddSteps from "./AddSteps";
import Pagination from "../Pagination/Pagination";
import { Logout, shouldLogout } from '../Common/Common'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { FaEdit, FaEye, FaPlus } from "react-icons/fa";
import Swal from "sweetalert2";
import { useGetAllCategoryForKBMutation, useGetAllFlowsbyCategoryMutation, useGetAllQuestionsMutation, useGetIntentByIdMutation, useGetFlowByIdMutation, useDeleteQuestionMutation, useDeleteFlowMutation, useGetAllQuestionsForDropdownMutation } from "./Api";
import { FiTrash2 } from "react-icons/fi";
import toastService from "../../services/toastService";

const Knowledgebase = () => {

    // const { id } = useParams()

    const location = useLocation();
    const id = location.state?.id;

    const [getAllCategoryApi, { isLoading }] = useGetAllCategoryForKBMutation()
    const [getAllFlowByCategoryApi, { isLoading: getFlowIsLoading }] = useGetAllFlowsbyCategoryMutation()
    const [getAllQuestionsApi, { isLoading: getQuestionsIsLoading }] = useGetAllQuestionsMutation()
    const [getIntentByIdApi, { isLoading: getIntentByIdIsloading }] = useGetIntentByIdMutation()
    const [getFlowByIdApi, { isLoading: getFlowByIdIsloading }] = useGetFlowByIdMutation()
    const [deleteQuestionApi, { isLoading: deleteQuestionIsloading }] = useDeleteQuestionMutation()
    const [deleteFlowApi, { isLoading: deleteFlowIsloading }] = useDeleteFlowMutation()
    const [getAllQuestionsForDropdownApi, { isLoading: getAllQuestionIsLoading }] = useGetAllQuestionsForDropdownMutation()


    const [selectedIssue, setSelectedIssue] = useState(null);
    const [selectedFlow, setSelectedFlow] = useState(null);
    const [allCategory, setAllCategory] = useState([])
    const [selectedData, setSelectedData] = useState([])
    const [troubleshootingFlow, setTroubleshootingFlow] = useState([]);
    const [questions, setQuestions] = useState([]);
    const [questionsForDropdown, setQuestionsForDropdown] = useState([]);

    const [selectedOptions, setSelectedOptions] = useState();
    const [toggle, setToggle] = useState(false)
    const [question, setQuestion] = useState(null)

    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    // handle refetch
    const [status, setStatus] = useState(false)
    const [flowStatus, setFlowStatus] = useState(false)
    const [questionStatus, setQuestionStatus] = useState(false)


    const navigate = useNavigate()

    const startEntry = totalRecords === 0
        ? 0
        : (currentPage - 1) * rowsPerPage + 1;

    const endEntry = Math.min(currentPage * rowsPerPage, totalRecords);

    const handleToggle = () => {
        setToggle(prev => !prev);
    };

    useEffect(() => {
        getAllCategory()
    }, [status])

    useEffect(() => {
        setSelectedFlow(null)
    }, [selectedIssue])

    useEffect(() => {
        if (id) {
            setSelectedIssue(Number(id));
        }
    }, [id])

    useEffect(() => {
        if (selectedIssue && allCategory?.length > 0) {
            const result = allCategory.find(
                item => Number(item.id) === Number(selectedIssue)
            );
            setSelectedData(result);
        }
    }, [selectedIssue, allCategory]);

    useEffect(() => {
        if (selectedIssue) {
            getTroubleshootingFlow()
        }
    }, [selectedIssue, flowStatus])

    const getAllCategory = async () => {
        try {
            const response = await getAllCategoryApi()

            if (response?.data?.success) {

                if (response?.data?.data.length > 0) {
                    setAllCategory(response?.data?.data)
                    // setSelectedIssue(response?.data?.data[0]?.id)
                } else {
                    setSelectedIssue(null)
                    setAllCategory([])
                }

            } else {
                if (shouldLogout(response.error)) {
                    return Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, "err")
        }
    }

    const getTroubleshootingFlow = async () => {
        try {
            const response = await getAllFlowByCategoryApi({ category_id: selectedIssue })

            if (response?.data?.success) {

                if (response?.data?.data.length > 0) {
                    setTroubleshootingFlow(response?.data?.data)
                    // setSelectedFlow(response?.data?.data[0]?.id)
                } else {
                    setSelectedFlow(null)
                    setTroubleshootingFlow([])
                }

            } else {
                if (shouldLogout(response.error)) {
                    return Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, "err")
        }
    }

    useEffect(() => {
        if (selectedFlow) {
            getQuestions()
        } else {
            setQuestions([])
        }
    }, [selectedFlow, rowsPerPage, currentPage, questionStatus])

    const getQuestions = async () => {
        try {
            const response = await getAllQuestionsApi({
                "flow_id": selectedFlow,
                "page": currentPage,
                "limit": rowsPerPage,
            })

            if (response?.data?.success) {

                if (response?.data?.data?.steps?.length > 0) {
                    setQuestions(response?.data?.data?.steps)
                    setTotalRecords(response?.data?.data?.pagination.total || 0);
                    setTotalPages(response?.data?.data?.pagination.totalPages || 1);
                } else {
                    setQuestions([])
                }
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, "err")
        }
    }

    // for dropdown

    useEffect(() => {
        if (selectedFlow) {
            getAllQuestionsForDropdown()
        }
    }, [selectedFlow, questionStatus])

    const getAllQuestionsForDropdown = async () => {
        try {
            const response = await getAllQuestionsForDropdownApi({
                "flow_id": selectedFlow,
            })

            if (response?.data?.success) {

                if (response?.data?.data?.length > 0) {
                    setQuestionsForDropdown(response?.data?.data)
                } else {
                    setQuestionsForDropdown([])
                }
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, "err")
        }
    }

    // handle toggle 
    const handleToggleRow = (id) => {
        const selectedQuestion = questions?.find(item => item.id === id);
        setSelectedOptions(selectedQuestion);
        handleToggle()
    };

    // create Issue category
    const [isIssueDrawerOpen, setIsIssueDrawerOpen] = useState(false);

    const handleCreateIssue = () => {
        setIsIssueDrawerOpen(true);
    };

    const handleIssueCloseDrawer = () => {
        setIsIssueDrawerOpen(false);
    };

    const handleIssueSave = () => {
        handleIssueCloseDrawer(); // Close 
        setStatus(!status)  // for get new data after new intent upload
    };

    // update Issue category
    const [isUpdateIssueDrawerOpen, setIsUpdateIssueDrawerOpen] = useState(false);
    const [intentData, setIntentData] = useState()

    // const handleUpdateIssue = () => {
    //     setIsUpdateIssueDrawerOpen(true);
    // };

    const handleUpdateIssueCloseDrawer = () => {
        setIsUpdateIssueDrawerOpen(false);
    };

    const handleUpdateIssueSave = () => {
        handleUpdateIssueCloseDrawer(); // close toggle
        setStatus(!status)  // for get new data after new role upload
    };

    // handle create flow 
    const [isFlowDrawerOpen, setIsFlowDrawerOpen] = useState(false);

    const handleCreateFlow = () => {
        setIsFlowDrawerOpen(true);
    };

    const handleFlowCloseDrawer = () => {
        setIsFlowDrawerOpen(false);
    };

    const handleFlowSave = () => {
        handleFlowCloseDrawer(); // Close 
        setFlowStatus(!flowStatus)  // for get new data after new intent upload
    };

    // update flow category
    const [isUpdateFlowDrawerOpen, setIsUpdateFlowDrawerOpen] = useState(false);
    const [flowData, setFlowData] = useState()

    // const handleUpdateFlow = () => {
    //     setIsUpdateFlowDrawerOpen(true);
    // };

    const handleUpdateFlowCloseDrawer = () => {
        setIsUpdateFlowDrawerOpen(false);
    };

    const handleUpdateFlowSave = () => {
        handleUpdateFlowCloseDrawer(); // close toggle
        setFlowStatus(!flowStatus)  // for get new data after new role upload
    };

    // handle create Options 
    const [isQuestionDrawerOpen, setIsQuestionDrawerOpen] = useState(false);

    const handleCreateQuestion = () => {
        setIsQuestionDrawerOpen(true);
    };

    const handleQuestionCloseDrawer = () => {
        setIsQuestionDrawerOpen(false);
    };

    const handleQuestionSave = () => {
        handleQuestionCloseDrawer(); // Close 
        setQuestionStatus(!questionStatus)  // for get new data after new intent upload
    };


    // update options
    const [isUpdateQuestionsDrawerOpen, setIsUpdateQuestionsDrawerOpen] = useState(false);
    const [questionsData, setQuestionsData] = useState()

    // const handleUpdateQuestions = () => {
    //     setIsUpdateQuestionsDrawerOpen(true);
    // };

    const handleUpdateQuestionsCloseDrawer = () => {
        setIsUpdateQuestionsDrawerOpen(false);
    };

    const handleUpdateQuestionsSave = () => {
        handleUpdateQuestionsCloseDrawer(); // close toggle
        setQuestionStatus(!questionStatus)  // for get new data after new role upload
    };

    // get new flow or category id
    const addlatestValue = async (module, id) => {
        if (module == 'category') {
            setSelectedIssue(id)
        } else {
            setSelectedFlow(id)
        }
    }

    // get intent by id 
    const getIntentById = async () => {
        try {
            const response = await getIntentByIdApi({ id: selectedIssue })

            if (response.data.success) {
                setIsUpdateIssueDrawerOpen(true)
                setIntentData(response?.data?.data)
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    // get flow by Id
    const getFlowById = async () => {
        try {
            const response = await getFlowByIdApi({ id: selectedFlow })

            if (response.data.success) {
                setIsUpdateFlowDrawerOpen(true)
                setFlowData(response?.data?.data)
            } else {
                if (shouldLogout(response.error)) {
                    Logout(navigate);
                }
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const getQuestionById = async (id) => {
        try {
            const result = questions.find((item) => item.id === id);
            setIsUpdateQuestionsDrawerOpen(true);
            setQuestion(result)
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const deleteQuestion = async (id) => {
        try {
            const isDarkMode = localStorage.getItem("theme") === "dark";

            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Deleting this question will also delete all associated options.",
                icon: "warning",

                showCancelButton: true,
                confirmButtonText: "Delete",
                cancelButtonText: "Cancel",

                confirmButtonColor: "#d32f2f",
                cancelButtonColor: isDarkMode ? "#475569" : "#757575",

                background: isDarkMode ? "#1e293b" : "#fdfdfd",
                color: isDarkMode ? "#f8fafc" : "#212121",

                iconColor: "#ef4444",

                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true,

                customClass: {
                    popup: isDarkMode ? "swal-dark-popup" : "",
                    title: isDarkMode ? "swal-dark-title" : "",
                    confirmButton: isDarkMode ? "swal-dark-confirm" : "",
                    cancelButton: isDarkMode ? "swal-dark-cancel" : "",
                },
            });

            if (!result.isConfirmed) return;

            const response = await deleteQuestionApi({ question_id: id })

            if (response?.data?.success) {
                toastService.success(response?.data?.message);
                setQuestionStatus(!questionStatus)
            } else {
                if (shouldLogout(response.error)) {
                    return Logout(navigate);
                }
                toastService.error(response.error.data.message);
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }

    const deleteFlow = async (id) => {
        try {

            // const result = await Swal.fire({
            //     title: "Are you sure?",
            //     text: "Deleting this Flow will also delete all associated questions and options.",
            //     icon: "warning",
            //     showCancelButton: true,
            //     confirmButtonText: "Delete",
            //     cancelButtonText: "Cancel",
            //     confirmButtonColor: "#d32f2f",
            //     cancelButtonColor: "#757575",
            //     background: "#fdfdfd",
            //     color: "#212121",
            //     iconColor: "#d32f2f",
            //     allowOutsideClick: false,
            //     allowEscapeKey: false,
            //     reverseButtons: true,
            // });

            const isDarkMode = localStorage.getItem("theme") == "dark";

            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Deleting this Flow will also delete all associated questions and options.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Delete",
                cancelButtonText: "Cancel",
                confirmButtonColor: "#d32f2f",
                cancelButtonColor: isDarkMode ? "#475569" : "#757575",

                background: isDarkMode ? "#1e293b" : "#fdfdfd",
                color: isDarkMode ? "#f8fafc" : "#212121",

                iconColor: "#ef4444",

                allowOutsideClick: false,
                allowEscapeKey: false,
                reverseButtons: true,

                customClass: {
                    popup: isDarkMode ? "swal-dark-popup" : "",
                    title: isDarkMode ? "swal-dark-title" : "",
                    confirmButton: isDarkMode ? "swal-dark-confirm" : "",
                    cancelButton: isDarkMode ? "swal-dark-cancel" : "",
                },
            });

            if (!result.isConfirmed) return;

            const response = await deleteFlowApi({ flow_id: selectedFlow })

            if (response?.data?.success) {
                toastService.success(response?.data?.message);
                setFlowStatus(!flowStatus)
                setQuestionStatus(!questionStatus)
            } else {
                if (shouldLogout(response.error)) {
                    return Logout(navigate);
                }
                toastService.error(response.error.data.message);
            }
        } catch (err) {
            console.log(err, 'err')
        }
    }
    return (
        <div>
            {isLoading || getFlowIsLoading || getQuestionsIsLoading || getIntentByIdIsloading || getFlowByIdIsloading || deleteQuestionIsloading || deleteFlowIsloading || getAllQuestionIsLoading ? <Loader /> :
                <div>
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <ul className="breadcrumb mb-0">
                                <li className="breadcrumb-item">Knowledge Base</li>
                                <li className="breadcrumb-item active">KB Management</li>
                            </ul>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="row">
                            <div className="p-6">

                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                        <h3 className="h4 mb-1 drawer-header">
                                            Knowledge Base Management
                                        </h3>
                                        <p className="mb-0 text-muted">
                                            Manage Issue Category, Troubleshooting Flow, Questions and Customer Responses
                                        </p>
                                    </div>
                                </div>

                                <div className="card p-3 mb-4">


                                    <div className="card p-3 mb-4">
                                        <div className="card-body">

                                            <div className="row g-5">

                                                <div className="col-md-6">

                                                    <label className="form-label fw-semibold">
                                                        Issue Category *
                                                    </label>

                                                    <div className="d-flex gap-2">

                                                        {id ? <select
                                                            className="form-select form-select-sm"
                                                            onChange={(e) => setSelectedIssue(Number(e.target.value))}
                                                            value={selectedIssue}
                                                        >
                                                            {(id
                                                                ? allCategory?.filter(item => item.id === Number(id))
                                                                : allCategory
                                                            )?.map(item => (
                                                                <option
                                                                    key={item.id}
                                                                    value={item.id}
                                                                    disabled={item.status !== "active"}
                                                                >
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                        </select> :

                                                            <select
                                                                className="form-select form-select-sm"
                                                                value={selectedIssue}
                                                                onChange={(e) => setSelectedIssue(e.target.value)}
                                                                disabled={!allCategory?.length}
                                                            >
                                                                {allCategory?.length > 0 ? (
                                                                    <>
                                                                        <option value="">
                                                                            Select Category
                                                                        </option>

                                                                        {allCategory.map((item) => (
                                                                            <option
                                                                                key={item.id}
                                                                                value={item.id}
                                                                                disabled={item.status !== "active"}
                                                                            >
                                                                                {item.name}
                                                                            </option>
                                                                        ))}
                                                                    </>
                                                                ) : (
                                                                    <option value="">
                                                                        No issue categories found
                                                                    </option>
                                                                )}
                                                            </select>
                                                        }


                                                        <div className="d-flex gap-2">
                                                            {!id &&
                                                                <button className="btn btn-primary btn-sm" onClick={handleCreateIssue}>
                                                                    <FaPlus size={15} />
                                                                </button>
                                                            }
                                                            {id && allCategory?.length > 0 && (
                                                                <button className="btn btn-primary btn-sm" onClick={getIntentById}>
                                                                    <FaEdit size={15} />
                                                                </button>
                                                            )}
                                                            {/* <button className="btn btn-danger btn-sm">
                                                                <FiTrash2 size={15} />
                                                            </button> */}
                                                        </div>
                                                    </div>
                                                    <small className="text-muted d-block mt-1 fst-italic">
                                                        {id
                                                            ? <>
                                                                Note: To update an issue category, click the <FaEdit /> button.
                                                            </>
                                                            :
                                                            <>
                                                                Note: To create a new issue category, click the <b>+</b> button.
                                                            </>
                                                        }
                                                    </small>
                                                </div>

                                                <div className="col-md-6">

                                                    <label className="form-label fw-semibold">
                                                        Troubleshooting Flow *
                                                    </label>

                                                    <div className="d-flex gap-2">
                                                        <select
                                                            className="form-select form-select-sm"
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                setSelectedFlow(value === "" ? null : Number(value));
                                                            }}
                                                            value={selectedFlow || ""}
                                                            disabled={!selectedIssue || !troubleshootingFlow?.length}
                                                        >
                                                            {!selectedIssue ? (
                                                                <option value="">Select category first</option>
                                                            ) : troubleshootingFlow?.length > 0 ? (
                                                                <>
                                                                    <option value="">Select Flow</option>

                                                                    {troubleshootingFlow.map((item) => (
                                                                        <option
                                                                            key={item.id}
                                                                            value={item.id}
                                                                            disabled={item.status !== "active"}
                                                                        >
                                                                            {item.name}
                                                                        </option>
                                                                    ))}
                                                                </>
                                                            ) : (
                                                                <option value="">
                                                                    No troubleshooting flow found for this category
                                                                </option>
                                                            )}
                                                        </select>

                                                        <div className="d-flex gap-2">
                                                            {selectedIssue &&
                                                                <button
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={handleCreateFlow}
                                                                >
                                                                    <FaPlus size={15} />
                                                                </button>
                                                            }
                                                            {id && selectedFlow && troubleshootingFlow?.length > 0 && (
                                                                <button
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={getFlowById}
                                                                >
                                                                    <FaEdit size={15} />
                                                                </button>
                                                            )}

                                                            {selectedFlow && troubleshootingFlow?.length > 0 && (
                                                                <button
                                                                    className="btn btn-danger btn-sm"
                                                                    onClick={deleteFlow}
                                                                >
                                                                    <FiTrash2 size={15} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <small className="text-muted d-block mt-1 fst-italic">
                                                        {id ? (
                                                            <>
                                                                Note: To update a troubleshooting flow, click the <FaEdit className="me-1" /> button.
                                                            </>
                                                        ) : (
                                                            <>
                                                                Note: To create a new troubleshooting flow, click the <b>+</b> button.
                                                            </>
                                                        )}
                                                    </small>
                                                </div>

                                                <div className="col-6">
                                                    <label className="form-label fw-semibold">
                                                        Keywords
                                                    </label>

                                                    <div>
                                                        {selectedData?.keywords?.length > 0 ? (
                                                            selectedData.keywords.map((kw, index) => (
                                                                <span
                                                                    key={index}
                                                                    style={{
                                                                        background: "#e9ecef",
                                                                        padding: "4px 8px",
                                                                        borderRadius: "12px",
                                                                        marginRight: "5px",
                                                                        marginBottom: "5px",
                                                                        display: "inline-block",
                                                                        fontSize: "12px",
                                                                        color: "#212529"
                                                                    }}
                                                                >
                                                                    {kw}
                                                                </span>
                                                            ))
                                                        ) : (
                                                            <span
                                                                className="text-muted"
                                                                style={{ fontSize: "12px", fontStyle: "italic" }}
                                                            >
                                                                No keywords available
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                    <div className="card p-3 mb-4">

                                        <div className="card-header bg-white d-flex justify-content-between align-items-center border-0">
                                            <div>
                                                <h5 className="mb-1 fw-bold" style={{ color: "#1f2937" }}>
                                                    Questions
                                                </h5>

                                                <small className="text-muted" style={{ fontSize: "12.5px" }}>
                                                    Manage and configure workflow questions
                                                </small>
                                            </div>

                                            {selectedFlow &&
                                                <button className="btn btn-primary d-flex align-items-center gap-2" onClick={handleCreateQuestion}>
                                                    <FaPlus />
                                                    Add Question
                                                </button>
                                            }

                                        </div>

                                        <div className="card shadow-sm border-0 p-3 mb-4 table-responsive">
                                            <table className="table table-hover mb-0">
                                                <thead>
                                                    <tr>
                                                        <th>Question</th>
                                                        <th>Solution</th>
                                                        {/* <th>Is Final Step</th> */}
                                                        <th>Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {!getQuestionsIsLoading && questions?.length > 0 ? questions?.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                {item.question}
                                                            </td>

                                                            <td>
                                                                {item.solution_text ? (
                                                                    <div
                                                                        dangerouslySetInnerHTML={{ __html: item.solution_text }}
                                                                    />
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>

                                                            {/* <td>{item.is_final_step === 1 ? "Yes" : "No"}</td> */}
                                                            <td>
                                                                <FaEdit
                                                                    size={18}
                                                                    style={{ cursor: "pointer", marginRight: "12px", color: "#0d6efd" }}
                                                                    onClick={() => getQuestionById(item.id)}
                                                                />

                                                                <FiTrash2
                                                                    size={18}
                                                                    style={{ cursor: "pointer", color: "#dc3545" }}
                                                                    onClick={() => deleteQuestion(item.id)}
                                                                />
                                                            </td>

                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan="4" className="text-center text-muted py-4" style={{ fontStyle: "italic", backgroundColor: "#f9f9f9" }}>
                                                                No data found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            {/* Pagination */}
                                            {questions?.length > 0 &&
                                                <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-3 gap-2">

                                                    <div className="d-flex align-items-center gap-1 small">

                                                        <span>Show</span>

                                                        <select
                                                            className="form-select form-select-sm page-size-select"
                                                            value={rowsPerPage}
                                                            onChange={(e) => {
                                                                setRowsPerPage(Number(e.target.value));
                                                                setCurrentPage(1);
                                                            }}
                                                        >
                                                            <option value={5}>5</option>
                                                            <option value={10}>10</option>
                                                            <option value={15}>15</option>
                                                        </select>

                                                        <span>entries</span>

                                                    </div>

                                                    <div className="small text-muted">
                                                        Showing {startEntry} to {endEntry} of {totalRecords} entries
                                                    </div>

                                                    <Pagination
                                                        currentPage={currentPage}
                                                        totalPages={totalPages}
                                                        maxPagesToShow={rowsPerPage}
                                                        onPageChange={(page) => setCurrentPage(page)}
                                                    />

                                                </div>
                                            }
                                        </div>
                                    </div>

                                    {toggle &&
                                        <div className="card shadow-sm border-0">

                                            <div className="card-body">

                                                <div className="row g-4">

                                                    <div className="col-md-4">
                                                        <label className="form-label fw-semibold">
                                                            Question *
                                                        </label>

                                                        <textarea
                                                            className="form-control"
                                                            rows="4"
                                                            style={{ resize: "none" }}
                                                            value={selectedOptions?.question}
                                                        />
                                                    </div>

                                                    <div className="col-md-4">

                                                        <label className="form-label fw-semibold">
                                                            Options *
                                                        </label>

                                                        {selectedOptions?.options?.length > 0 ? (
                                                            selectedOptions.options.map((opt, index) => (
                                                                <input
                                                                    key={index}
                                                                    className="form-control mb-2"
                                                                    value={opt?.option_label}
                                                                />
                                                            ))
                                                        ) : (
                                                            <div className="text-muted fst-italic">
                                                                No response found
                                                            </div>
                                                        )}

                                                        <button className="btn btn-primary btn-sm">
                                                            <FaPlus size={15} />
                                                        </button>

                                                    </div>

                                                    <div className="col-md-4">

                                                        <label className="form-label fw-semibold">
                                                            Resolution Text *
                                                        </label>

                                                        <textarea
                                                            className="form-control"
                                                            rows="6"
                                                            defaultValue="Refresh license cache and ask user to login again. If the issue persists escalate to level 2 support."
                                                            style={{ resize: "none" }}
                                                        />

                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>

                    {isIssueDrawerOpen && (
                        <AddIntent
                            mode="add"
                            onClose={handleIssueCloseDrawer}
                            onSave={handleIssueSave}
                            addlatestValue={addlatestValue}
                        />

                    )}

                    {isUpdateIssueDrawerOpen && (
                        <AddIntent
                            mode="update"
                            onClose={handleUpdateIssueCloseDrawer}
                            onSave={handleUpdateIssueSave}
                            data={intentData}
                        />
                    )}

                    {isFlowDrawerOpen && (
                        <AddFlow
                            mode="add"
                            onClose={handleFlowCloseDrawer}
                            onSave={handleFlowSave}
                            selectIntent={selectedIssue}
                            addlatestValue={addlatestValue}
                        />

                    )}

                    {isUpdateFlowDrawerOpen && (
                        <AddFlow
                            mode="update"
                            onClose={handleUpdateFlowCloseDrawer}
                            onSave={handleUpdateFlowSave}
                            data={flowData}
                            selectIntent={selectedIssue}
                        />
                    )}

                    {isQuestionDrawerOpen && (
                        <AddSteps
                            mode="add"
                            onClose={handleQuestionCloseDrawer}
                            onSave={handleQuestionSave}
                            questions={questionsForDropdown}
                            selectIntent={selectedIssue}
                            selectFlow={selectedFlow}
                        />

                    )}

                    {isUpdateQuestionsDrawerOpen && (
                        <AddSteps
                            mode="update"
                            onClose={handleUpdateQuestionsCloseDrawer}
                            onSave={handleUpdateQuestionsSave}
                            questions={questionsForDropdown}
                            selectIntent={selectedIssue}
                            selectFlow={selectedFlow}
                            data={question}
                        />

                    )}
                </div>
            }
        </div>

    );
};

export default Knowledgebase;  
